var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"monitor-rule",class:_vm.wrapperClass},[(_vm.rule)?_c('v-icon',{staticClass:"monitor-rule__icon"},[_vm._v(" "+_vm._s(_vm.ruleIcon)+" ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }